<template>
  <!-- 支付结果页成功/到账中引导气泡（无按钮） -->
  <agent-tip-frame
    class="pay-success-tip"
    :tip-style="tipStyle"
    :assistant-name="assistantName"
    @close="$emit('close')"
  >
    <template #message>{{ message }}</template>
  </agent-tip-frame>
</template>

<script>
import AgentTipFrame from './AgentTipFrame.vue';

/**
 * PaySuccessTip — 支付成功/到账中结果页 agent-tip
 */
export default {
  name: 'PaySuccessTip',
  components: { AgentTipFrame },
  props: {
    tipStyle: {
      type: Object,
      default: () => ({})
    },
    assistantName: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.pay-success-tip >>> .agent-tip__text {
  margin-bottom: 0;
  white-space: pre-line;
}

.pay-success-tip >>> .agent-tip__actions {
  display: none;
}
</style>
